import React, { useState, useEffect } from "react";
import { InputAdornment } from "@mui/material";
import SideMenu from "../../../Components/SideMenu";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";

import OutlinedInput from "@mui/material/OutlinedInput";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useGlobalContext } from "../../../../../../context";
import "../../../Dashboard.css";
import Styles from "../../../../../Slices/Mof/Styles.json";
import "../../../Dashboard.css";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import AddBoxIcon from "@mui/icons-material/AddBox";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
// import Chip from "@mui/material/Chip";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import ApiSetting from "../../../../../../Settings/ApiSettings.json";
import Cookies from "universal-cookie";
import { ItemDragging } from "devextreme-react/list";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import swal from 'sweetalert';
import $ from 'jquery'

// Import css files
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get("id");
const cookies = new Cookies();

export default function SourceOfIncome(props) {
const [render,setRender]=useState(0)
const [reload, setReload] = useState(false)
const [localListOfIncoenResourceValue,setLocalListOfIncoenResourceValue]=useState(props?.listOFIncomeResourceValue)

const AccesPrivilegeAdd=()=>{
  let check=false;
   props?.Access?.map(data=>{
        if(data==2){
          check=true;
        }
   })

   return check;
 }
 
 const AccessPrivilegeViewOnly=()=>{
  let check=false;
   props?.Access?.map(data=>{
        if(data==1){
          check=true;
        }
        if(data==2 || data==3){
           check=false;
        }
   })

   return check;
}
 useEffect(() => {
  console.log(props?.Access)
 }, [])
 

 const AccesPrivilegeView=()=>{
  let check=false;
   props?.Access?.map(data=>{
        if(data==1){
          check=true;
        }
   })
   if(props?.Access?.length==0){
    check=true;
   }

   return check;
 }

 const AccesPrivilegeEdit=()=>{
  let check=false;
   props?.Access?.map(data=>{
        if(data==3){
          check=true;
        }
   })

   return check;
 }

 const AccesPrivilegeDelete=()=>{
  let check=false;
   props?.Access?.map(data=>{
        if(data==4){
          check=true;
        }
   })

   return check;
 }
 useEffect(()=>{
  
  if(props?.Access?.length==0){
  function closeMessage(el) {
    el.addClass('is-hidden');
  }
  
  $('.js-messageClose').on('click', function(e) {
    closeMessage($(this).closest('.Message'));
  });
  
  $('#js-helpMe').on('click', function(e) {
    alert('Help you we will, young padawan');
    closeMessage($(this).closest('.Message'));
  });
  
  $('#js-authMe').on('click', function(e) {
    alert('Okelidokeli, requesting data transfer.');
    closeMessage($(this).closest('.Message'));
  });
  
  $('#js-showMe').on('click', function(e) {
    alert("You're off to our help section. See you later!");
    closeMessage($(this).closest('.Message'));
  });
  
  $(document).ready(function() {
    setTimeout(function() {
      closeMessage($('#js-timer'));
    }, 5000);
  });
}
// setReload(!reload)

 },[props?.Access])

  return (
    <div>
  {/* ####===>income resource with value  */}
   
      
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexFlow: "row wrap",

          // border: "1px solid",
          borderColor: "#5f7b8a",
          borderRadius: 10,
          margin: 10,
          paddingBottom: 10,
        }}
      >

    
        {AccesPrivilegeAdd() ? (
          <div
            style={{
              display: "flex",
              width: "100%",
              minWidth: 200,
              marginTop: 10,
              paddingLeft: 10,
              paddingTop: 10,
              paddingRight: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              <AddCircleSharpIcon
                onClick={() => {
                   setRender(render+1)
                   console.log("render")
                   props?.setListOFIncomeResourceValue((list) => [
                    ...list,
                    {
                      index: props?.listOFIncomeResourceValue.length + 1,
                      resource: "",
                      other_resource_value: "",
                      amount: 0,
                      comments: "",
                      newValue:true
                    },
                  ]);
                  props?.setRenderCheck(!props?.renderCheck)
                  
                }}
                style={{
                  fontSize: 40,
                  // borderRadius: "10px",
                  // backgroundColor: Styles.Colors.MOF_Modal_BGcolor,
                  color: Styles.Colors.MOF_Modal_BGcolor,
                  cursor: "pointer",
                }}
              />
            </FormControl>

            <Typography className="fontForError"></Typography>
          </div>
        ) : null}

        {props?.listOFIncomeResourceValue.length > 0
          ? props?.listOFIncomeResourceValue.map((data) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",
                  width: "100%",
                  // border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: "1px 10px",
                  padding: 2,
                }}
              >
                {(AccesPrivilegeDelete() && (data.index!=0&&data.index!=1))||data?.newValue? (
                  <div
                    style={{
                      display: "flex",
                      // width: "5%",
                      flex: 0.1,
                      minWidth: 20,
                      marginTop: 10,
                      paddingLeft: 10,
                      paddingTop: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl fullWidth>
                      <RemoveCircleSharpIcon
                        onClick={() => {
                            props?.setListOFIncomeResourceValue(
                                props?.listOFIncomeResourceValue.filter(
                                (itm) => itm.index != data.index
                              )
                            );
                           props?.setRenderCheck(!props?.renderCheck)

                        }}
                        style={{
                          fontSize: 40,
                          // borderRadius: "10px",
                          // backgroundColor: Styles.Colors.MOF_Modal_BGcolor,
                          color: Styles.Colors.MOF_Modal_BGcolor,
                          cursor: "pointer",
                        }}
                      />
                    </FormControl>

                    <Typography className="fontForError"></Typography>
                  </div>
                ) : null}

                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="career-simple-select-label">
                      مصدر الدخل
                    </InputLabel>
                    <Select
                      disabled={AccessPrivilegeViewOnly()}
                      labelId="career-simple-select-label"
                      id="career-simple-select"
                      value={data.resource}
                      label="مصادر الدخل"
                      onChange={(e) => {
                        props.setResourceForIncomeResource(
                          data,
                          e.target.value
                        );
                        props?.setRenderCheck(!props?.renderCheck)
                      }}
                    >
                      {props?.incomeResourceValuesArrOBJ &&
                        props?.incomeResourceValuesArrOBJ.length > 0 &&
                        props?.incomeResourceValuesArrOBJ.map(
                          (incomeResourceValue, index) => {
                            return (
                              <MenuItem
                                key={
                                  "incomeResourceValue_" +
                                  incomeResourceValue.id
                                }
                                value={incomeResourceValue.resource}
                              >
                                {incomeResourceValue.resource}
                              </MenuItem>
                            );
                          }
                        )}
                    </Select>
                  </FormControl>

                  <Typography className="fontForError">
                    {/* {ErrorMessage.CalculationTypeError} */}
                  </Typography>
                </div>

                {data.resource == "other" ? (
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      minWidth: 200,
                      marginTop: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl fullWidth>
                      <TextField
                        disabled={AccessPrivilegeViewOnly()}
                        label="مصدر الدخل الاخر"
                        variant="outlined"
                        value={data.other_resource_value}
                        onChange={(e) => {
                          props.setOtherResourceForIncomeResource(
                            data,
                            e.target.value
                          );
                          props?.setRenderCheck(!props?.renderCheck)

                        }}
                      />
                    </FormControl>
                    <Typography className="fontForError">
                      {/* {ErrorMessage.activityTypeError} */}
                    </Typography>
                  </div>
                ) : null}

                <div
                  style={{
                    display: "flex",
                    flexDirection:'column',
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      disabled={
                        !AccessPrivilegeViewOnly() &&  data.resource != "نتيجة الحاسبة (تصاريح وحاسبة)"
                          ? data.resource == "نتيجة اللجنة الفاحصة"
                            ? props.disableIncome
                            : false
                          : true
                      }
                      label="الدخل الاجمالي"
                      type={"number"}
                      variant="outlined"
                      value={data.amount}
                      error={
                        data.resource == "نتيجة اللجنة الفاحصة" &&
                        props.disableIncome
                      }
                      onChange={(e) => {
                        if (
                          parseInt(e.target.value) >= props.selecetedAmount
                          &&
                          (data.resource ==
                            "نتيجة الحاسبة (تصاريح وحاسبة)" ||
                            data.resource == "نتيجة اللجنة الفاحصة")
                        ) {
                          props.setAmountForIncomeResource(
                            data,
                            e.target.value
                          );
                          props.summationOfAllResourcesFunction(
                            data,
                            e.target.value
                          );
                        } else if (
                          data.resource == "نتيجة اللجنة الفاحصة"
                        ) {
                          props.setsnackBar({
                            ...props.snackBar,
                            open: true,
                            severity: "warning",
                            message:
                              "المبلغ الاجمالي يجب ان لا يقل عن المبلغ المحدد من قبل لجنة الفاحصة",
                          });
                        } else {
                          props.setAmountForIncomeResource(
                            data,
                            e.target.value
                          );
                          props.summationOfAllResourcesFunction(
                            data,
                            e.target.value
                          );
                        }
                        props?.setRenderCheck(!props?.renderCheck)

                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {data.resource == "نتيجة اللجنة الفاحصة" &&
                    props.disableIncome
                      ? "لم تنهي اللجنة المدققة بعد من تدقيق المبلغ الاجمالي"
                      : data?.hint?data.hint:''}
                  </Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      disabled={!AccessPrivilegeViewOnly() && data.index!=0 &&data.index!=1 ? false : true}
                      label="الملاحظات "
                      multiline
                      minRows={4}
                      variant="outlined"
                      value={data.comments}
                      onChange={(e) => {
                        props.setCommentsForIncomeResource(
                          data,
                          e.target.value
                        );
                        props?.setRenderCheck(!props?.renderCheck)

                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {/* {ErrorMessage.activityTypeError} */}
                  </Typography>
                </div>

              </div>
            ))
          : null}
      </div>

      {
        AccesPrivilegeEdit()&&props?.ModeOfInsertData=='تحديث'?
        <div
          style={{
            display: "flex",
            marginTop: 10,
            backgroundColor: "#fefefe",
            paddingLeft: 10,
            paddingRight: 10,
            paddingBottom: 30,

            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
        

          <Button
            variant="contained"
            style={{
              backgroundColor: "#5f7b8a",
              width: "40%",
              fontSize: "20px",
            }}
            onClick={()=>{
              // if(props?.ModeOfInsertData_tow=="حساب")
              //     props.getCalculationsForAmount(2)
              // else 
              props?.storeDataOfForm(props?.section_id)

              props?.setRenderCheck(!props?.renderCheck)

            }
            }
          >
            {!props?.loading ? (
              'تحديث'
            ) : (
              <div className="spinner-border " role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </Button>
        </div>
       :null
      }
    </div>
  )
  // (<div className="notHaveAthunticatio">
  //       <div class="Message Message--orange w-100">
  //         <div class="Message-icon">
  //          <i class="bi bi-exclamation-triangle-fill"></i>
  //         </div>
  //         <div class="Message-body">
  //           <p>ليس لديك صلاحية لعرض تفاصيل هذا القسم</p>
  //         </div>
  //         <button class="Message-close js-messageClose"><i class="bi bi-x-lg"></i></button>
  //       </div>
  // </div>)
}
